import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType, DialogHeader } from '@checkmarx/cx-ui';
import Dialog from 'material-ui/Dialog';
import PortalTextBox from '../../portal/portalTextBox';

@inject('translationsStore') @observer
export default class AddTeamDialog extends Component {

    render() {

        const customContentStyle = {
            width: '475px'
        };

        const title = <DialogHeader 
                        title={this.props.translationsStore.translate('ADD_TEAM')}
                        closeClick={this.props.onCancel}
                        displayCloseButton
                    />;
        return(
                <Dialog
                    title={title}
                    modal={false}
                    className='portal-confirm-dialog'
                    contentStyle={customContentStyle}
                    bodyClassName='portal-confirm-dialog-body'
                    open={this.props.open}>
                    <div
                        data-cy='add-team-dialog'
                        className='add-item-dialog-wrapper'
                    >
                        <form onSubmit={this.props.onSave}>
                            <div className='input-wrapper'>
                                <PortalTextBox 
                                    dataCy='add-team-textfield'
                                    hintText={this.props.translationsStore.translate('TEAM_NAME')}
                                    floatingLabelText={this.props.translationsStore.translate('TEAM_NAME')}
                                    onChange={this.props.onChange}
                                    type='text'
                                    width='100%'
                                    value={this.props.teamName || ''}
                                />
                            </div>
                            <div className='buttons-wrapper'>
                                <span
                                    data-cy='team-edit-cancel-button'
                                    className='portal-blank-button'
                                    onClick={this.props.onCancel}
                                >
                                    {this.props.translationsStore.translate('CANCEL')}
                                </span>
                                <Button 
                                    type='submit'
                                    dataCy='add-team-button'
                                    disabled={!this.props.teamName || this.props.teamName.trim() == ''}
                                    inProgress={this.props.inProgress}
                                    text={this.props.translationsStore.translate('ADD_TEAM')}>
                                </Button>
                            </div>
                        </form>
                    </div>
                </Dialog>
        );
    }
}